export const uri = {
    menu: {
        list: '/butane/menu/level/one/list',//一级菜单列表
        add: '/butane/menu/level/one/save', //新增一级菜单
        edit: '/butane/menu/level/one/update', //修改一级菜单
        listAll: '/butane/menu/level/one/list/all', //获取全部菜单文章
    },
    subMenu: {
        list: '/butane/menu/level/two/list',//二级菜单列表
        add: '/butane/menu/level/two/save', //新增二级菜单
        edit: '/butane/menu/level/two/update', //修改二级菜单名称
        content: '/butane/menu/level/two/content/ide', //获取二级菜单内容
        updateContent: '/butane/menu/level/two/updateContent',//修改二级菜单内容
    },
    article: {
        list: '/butane/article/list', //文章列表
        add: '/butane/article/save', //新增文章
        edit: '/butane/article/update',//修改文章标题
        delete: '/butane/article/delete', //删除文章
        content: '/butane/article/content/ide',//获取文章内容
        updateContent: '/butane/article/updateContent',//修改文章内容
    },
}